module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row\">\r\n	<div class=\"format-table-properties\" style=\"height: 135px\">	\r\n		<table id=\"propMainTable\"></table>\r\n	</div>\r\n	<div id=\"propMainGridButtons\" class=\"\">\r\n		<button type=\"button\" title=\"new\" name=\"itemNew\" class=\"itemNew btn btn-default hvr-glow tbl-icon\">\r\n			<i class=\"fa pf-add\" style=\"\"></i>\r\n		</button>\r\n		<button type=\"button\" title=\"remove\"  name=\"itemRemove\" class=\"itemRemove btn btn-default hvr-glow tbl-icon\">\r\n			<i class=\"fa pf-delete icon-gradient\"></i>\r\n		</button>\r\n		<button type=\"button\" name=\"itemUp\" title=\"up\" class=\"itemUp btn btn-default hvr-glow tbl-icon\">\r\n			<i class=\"fa pf-icon-up pf-carot-down\" aria-expanded=\"true\" style=\"-webkit-transform: rotate(-180deg);\"></i>\r\n		</button>\r\n		<button type=\"button\" name=\"itemDown\" title=\"down\"  class=\"itemDown btn btn-default hvr-glow tbl-icon\" >\r\n			<i class=\"fa pf-carot-down\" aria-expanded=\"true\" style=\"\"></i>\r\n		</button>\r\n\r\n		<button type=\"button\" title=\"default list\"  name=\"defaultLists\" class=\"text-right defaultLists btn btn-default hvr-glow tbl-icon-lst\" style=\"float: right;\" >\r\n			<span class=\"fa fa-list-ul\"></span>\r\n		</button>\r\n	</div>\r\n</div>")
  }
  return __output;

}